'use es6';

import tinymce from 'tinymce';
import I18n from 'I18n';
import { CANVAS_CONTENT_GENERATION } from '../constants/toolbar';
import { ToolbarDropdownButton } from '../components/ContentAssistantSlashAndSelectionCommandsToolbarManager';
import { getSlashCommandOptionsForInlineDropdown } from './generative';
import { jsx as _jsx } from "react/jsx-runtime";
export const addControls = (editor, slashCommands, selectionCommands, isDisabled, brandVoiceOptions = {}) => {
  tinymce.canvas.addMenuItem(editor, CANVAS_CONTENT_GENERATION, {
    text: I18n.text('TinymcePlugins.hscontentgeneration.menuItem'),
    disabled: isDisabled,
    onClick: () => {
      const isHighlightingText = editor.selection && !editor.selection.isCollapsed();
      if (isHighlightingText) {
        editor.fire('hscontentgeneration:openSelectionPopover');
      } else {
        const filteredCommands = getSlashCommandOptionsForInlineDropdown(editor, slashCommands);
        editor.fire('hscontentgeneration:openSlashPopover', {
          filteredCommands
        });
      }
    }
  });
  tinymce.canvas.addButton(editor, CANVAS_CONTENT_GENERATION, {
    renderControl: () => {
      return /*#__PURE__*/_jsx(ToolbarDropdownButton, {
        brandVoiceOptions: brandVoiceOptions,
        editor: editor,
        isDisabled: isDisabled,
        slashCommands: slashCommands,
        selectionCommands: selectionCommands
      });
    }
  });
};